module.exports = __webpack_public_path__ + "static/media/icon_wheat_plus_one_1.a55f9217.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/game/textures/icon_wheat_plus_one_1.png
 ** module id = 618
 ** module chunks = 0
 **/